<template>
<div class="dados">
    <h1 class="font-weight-bold text-uppercase ml-2">Meus Saldos</h1>
    <hr class="linha-amarela ml-2" />

    <div class="container col">
        <b-row>
            <b-col cols="10">
                <i class="fas fa-user-tie fa-2x c-orange mr-2"></i>
                <h4 class="text-uppercase c-orange font-weight-bold d-inline">Balconista {{dadosUsuario.nome_usuario}} - {{dadosUsuario.construp_user_id}}</h4>
            </b-col>
            <b-col class="text-right">
                <button
                    class="btn btn-success align-button "
                    :disabled="realMoney < 50"
                    @click="$bvModal.show('allowModal')"
                >
                    Solicitar saque
                </button>
            </b-col>
        </b-row>
    </div>

    <b-col class="mt-5 mb-3" cols="12">
        <b-row>
            <b-col>
                <ClerkCard
                    :loading="loading"
                    title="Constru coins"
                    :coinQtd="coinQtd"
                    icon="img-contrucoin"
                    backgroundColor="bg-orange"
                    class="cardPointer"
                />
            </b-col>

            <b-col>
                <ClerkCard
                    :loading="loading"
                    title="Total em reais"
                    :realMoney="realMoney"
                    icon="fas fa-dollar-sign"
                    backgroundColor="bg-green"
                    class="cardPointer"
                />
            </b-col>

            <b-col>
                <ClerkCard
                    :loading="loading"
                    title="Saque pendente"
                    :withdrawMoney="allowBalance"
                    icon="fas fa-clock"
                    backgroundColor="bg-yellow"
                    class="cardPointer"
                />
            </b-col>
        </b-row>
    </b-col>
    <b-col cols="12">
        <h6 class="text-danger">Limite mínimo para saque: R$50*</h6>
        <div class="mt-5 mb-4">
            <span>
                <img src="@/assets/img/coin-logo.png" class="size-img img-fluid rounded" alt="Constru Coin">
            </span>
            <span class="ml-3 fs-28">Programa de Constru Coin - Aprenda como ganhar</span>
        </div>
        <div class="textTitle c-orange mt-5 mb-3">1ª Opção</div>
        <b-row>
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'Indique seu cupom para os clientes quando o mesmo for finalizar uma compra'"
                    icon="fas fa-people-arrows"
           
                />
            </b-col>
            <b-col cols="1" class="iconAlign">
                <i class="fas fa-arrow-right sizeIcon"></i>
            </b-col>
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'A cada R$ 1,00 gasto pelo cliente usando seu cupom ao finalizar um pedido, você receberá  1 Constru Coin'"
                    icon="img-contrucoin"
                />
            </b-col>
            <b-col cols="1" class="iconAlign">
                <i class="fas fa-arrow-right sizeIcon"></i>
            </b-col>
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'A cada 1000 Constru Coin você receberá R$10,00 (com saque mínimo de R$50,00)'"
                    icon="fas fa-dollar-sign"
                />
            </b-col>
        </b-row>
        <div class="textTitle c-orange mt-5 mb-3">2ª Opção</div>
        <b-row class="">
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'Faça orçamentos e pedidos usando a plataforma Constr Up (Logado como balconista)'"
                    icon="fas fa-laptop"
                    
                />
            </b-col>
            <b-col cols="1" class="iconAlign">
                <i class="fas fa-arrow-right sizeIcon"></i>
            </b-col>
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'O pedido ou orçamento gera um link de pagamento com o resumo dos produtos para enviar ao cliente'"
                    icon="fas fa-dollar-sign"
                />
            </b-col>
            <b-col cols="1" class="iconAlign">
                <i class="fas fa-arrow-right sizeIcon"></i>
            </b-col>
            <b-col>
                <ConstruCoinInfoCard 
                    :text="'Cliente efetuando o pagamento será enviado novas Constru Coins em sua conta'"
                    icon="img-contrucoin"
                />
            </b-col>
        </b-row>
    </b-col>
    <b-col cols="12" class="mt-5">
        <LogList/>
    </b-col>
</div>
</template>

<script>
import makeToast from '../../mixins/makeToast';
import { mapState } from "vuex";
import ClerkCard from "./ClerkCard.vue";
import ConstruCoinInfoCard from '@/components/Cards/ConstruCoinInfoCard.vue';
import LogList from './LogList.vue';

export default {
    components: { ClerkCard, LogList, ConstruCoinInfoCard },
    mixins: [makeToast],
    data() {
        return {
            coinQtd: 0,
            realMoney: 0,
            allowBalance:0,
            loading: false,
        }
    },

    mounted() {
        this.getCoins();
    },

    computed: {
        ...mapState(['token', 'dadosUsuario'])
    },

    methods: {
        getCoins() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/puxarCoins', this.dadosUsuario.id)
            .then((resp) => {
                this.coinQtd = resp.data.value;
                this.realMoney = this.coinQtd /100;
                this.allowBalance = resp.data.totalBlock ? resp.data.totalBlock/100 : '0,00';
            })
            .catch(() => {
                this.makeToast('Oopss', 'Houve um erro ao trazer os valores!', 'danger')
            })
            .finally(() => {
                this.$store.dispatch('endLoader')
            });
        }
    }
};
</script>

<style>
.sizeIcon {
    font-size: 4rem;
}
.iconAlign {
    margin-top: 40px;
}
.size-img {
    width: 60px;
}
.textTitle{
    font-size: 24px;
    /* color: orange; */
    font-weight: 500;
}
</style>